import React from "react";
import { Container, Card, Button } from "react-bootstrap";
import PageLayout from "../Layouts/PageLayout";
import LeftArrow from "../Assets/Icons/leftArrow.svg";
import MerchantIcon from "../Assets/Icons/merchantIcon.svg";
import CustomerIcon from "../Assets/Icons/customerIcon.svg";
import PendingIcon from "../Assets/Icons/pendingIcon.svg";
import RefundIcon from "../Assets/Icons/refundIcon.svg";
import AdminCard from "../Components/AdminCard";
import ProfileImg from "../Assets/Images/ProfileImg.png";
import EditIcon from "../Assets/Icons/editIcon.svg";
import SubscribeIcon from "../Assets/Icons/subscribeIcon.svg";
import ActiveIcon from "../Assets/Icons/activeIcon.svg"
import PayStackIcon from "../Assets/Icons/payStackIcon.svg"

export default function MerchantAccount() {
  return (
    <Container fluid>
      <PageLayout>
        <div className="backmerchant-acc-sec">
          <img src={LeftArrow} />
          <p>Back</p>
        </div>
        <div style={{ marginTop: "2.5rem" }}>
          <h1 className="customer-heading">Total Customers</h1>
          <div className="merchant-card-con">
            <AdminCard
              title="Total Merchants"
              img={MerchantIcon}
              id="41564"
              bottombarbg="#008BD9"
            />
            <AdminCard
              title="Pending Requests"
              img={PendingIcon}
              id="4654"
              bottombarbg="#FF7A00"
            />
            <AdminCard
              title="Active Installments"
              img={MerchantIcon}
              id="1564"
              bottombarbg="#008BD9"
            />
            <AdminCard
              title="Refund"
              img={RefundIcon}
              id="₦ 155461564"
              bottombarbg="#FF7A00"
            />
          </div>
        </div>
        <div>
          <Card
            style={{ paddingBottom: "4rem" }}
            className="merchant-profile-card"
          >
            <div className="merchant-profile-sec-one">
              <div className="merchant-profile-profile">
                <img src={ProfileImg} />
                <div className="merchant-profile-info">
                  <div className="merchant-profile-subscribe">
                    <p>Admin Name</p>
                    <div className="subscribe-sec">
                      <img src={SubscribeIcon} />
                      <h4>SUBSCRIBED</h4>
                    </div>
                  </div>
                  <div className="merchant-active-status">
                    <img src={ActiveIcon} />
                    <h5>Active</h5>
                  </div>
                </div>
              </div>
              <div className="merchant-profile-btns">
                <Button variant='danger'>Block Account</Button>
                <Button variant="dark">Send Mail</Button>
              </div>
            </div>
            <div className="merchant-profile-divider"></div>
            <div className="merchant-profile-details-parent">
            <div className="merchant-profile-details">
              <div className="merchant-profile-details-sec-con">
                <div className="merchant-profile-details-sec">
                  <p>Name</p>
                  <h2>Naseem Muneer</h2>
                </div>
                <div className="merchant-profile-details-sec">
                  <p>Address</p>
                  <h2>Islamabad, Pakistan</h2>
                </div>
                <div className="merchant-profile-details-sec">
                  <p>Country</p>
                  <h2>Pakistan</h2>
                </div>
              </div>
              <div className="merchant-profile-details-sec-con">
                <div className="profile-details-sec">
                  <p>Email Address</p>
                  <h2>naseembaloch7524@gmail.com</h2>
                </div>
                <div className="merchant-profile-details-sec">
                  <p>Phone Number</p>
                  <h2>+923160598938</h2>
                </div>
                <div className="merchant-profile-details-sec">
                  <p>Shop Address</p>
                  <h2>Islamabad, Pakistan</h2>
                </div>
              </div>
            </div>
            <Card className="paystack-card">
                <p>payment processors</p>
                <Button>
                    <img src={PayStackIcon} />
                    paystack
                </Button>
            </Card>
            </div>
          </Card>
        </div>
      </PageLayout>
    </Container>
  );
}
